import { render, staticRenderFns } from "./Rotate.vue?vue&type=template&id=c12e3984&"
import script from "./Rotate.vue?vue&type=script&lang=js&"
export * from "./Rotate.vue?vue&type=script&lang=js&"
import style0 from "./Rotate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports